import { LOCAL_STORAGE_KEYS } from "./constants/LocalStorageItems";
import { LocalStorage } from "./utils/LocalStorage";

const environment = process.env.REACT_APP_ENV || "local";

export function initializeFeatureFlags(): void {
  LocalStorage.saveItem(
    LOCAL_STORAGE_KEYS.clearingOptimisationToggleHidden,
    environment === "prod"
  );
}
